<app-drawer [isOpen]="_openFilters" (closeDrawer)="_closeDrawer()" style="position: relative; z-index: 9999999;">
  <div class="drawer-container flex-column">
    <div class="drawer-header">
      <div class="semi-bold">Filter By: </div>
      <button type="button" class="btn-close" (click)="_closeDrawer()">
        <img src="../../../assets/img/icon-close.svg" class="close-icon" alt="">
      </button>
    </div>
    <div class="promo-stacks-filters">
      <div class="promo-stacks-filters-wrapper">
        <div class="promo-filters">
          <span class="filter-by">Genre</span>
          <div>
            <div class="genre-list-item">
              <input type="checkbox"
                [checked]="selectedGenres.includes('All')"
                (change)="toggleGenre($event)"
                value="All"
                > All
              </div>
              <div class="pill-bar">
                @for (genre of displayedGenres; track genre) {
                  <div
                    class="pill"
                    >
                  <input type="checkbox"
                    [checked]="selectedGenres.includes(genre)"
                    (change)="toggleGenre($event)"
                    value="{{ genre }}"
                    >
                  {{ genre }}
                </div>
              }
            </div>
          </div>
          @if (_genres && displayedGenres.length < _genres.length) {
            <button class="genre-load-more-btn" type="button" (click)="loadMoreGenres()"
              >
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 14 14" fill="none">
                            <path d="M8 6V1C8 0.734784 7.89464 0.48043 7.70711 0.292893C7.51957 0.105357 7.26522 0 7 0C6.73478 0 6.48043 
                            0.105357 6.29289 0.292893C6.10536 0.48043 6 0.734784 6 1V6H1C0.734784 6 0.48043 6.10536 0.292893 6.29289C0.105357 
                            6.48043 0 6.73478 0 7C0 7.26522 0.105357 7.51957 0.292893 7.70711C0.48043 7.89464 0.734784 8 1 8H6V13C6 13.2652 
                            6.10536 13.5196 6.29289 13.7071C6.48043 13.8946 6.73478 14 7 14C7.26522 14 7.51957 13.8946 7.70711 13.7071C7.89464 
                            13.5196 8 13.2652 8 13V8H13C13.2652 8 13.5196 7.89464 13.7071 7.70711C13.8946 7.51957 14 7.26522 14 7C14 6.73478 
                            13.8946 6.48043 13.7071 6.29289C13.5196 6.10536 13.2652 6 13 6H8Z" fill="#828282"/>
              </svg>
              More
            </button>
          }
        </div>
        <div class="promo-filters">
          <span class="filter-by">Promo Duration</span>
          <div class="pill-bar">
            <div class="pill">
              <input type="checkbox"
                [checked]="_selectedDuration.includes('All')"
                (change)="setDuration($event)"
                value="All"
                > All
              </div>
              @for (duration of durations; track duration) {
                <div
                  class="pill"
                  >
                <input type="checkbox"
                  [checked]="_selectedDuration.includes(duration)"
                  (change)="setDuration($event)"
                  value="{{ duration }}"
                  id="{{ duration }}"
                  >
                {{ duration }}
              </div>
            }
          </div>
        </div>
        <div class="promo-filters">
          <span class="filter-by">Book Price</span>
          <div class="pill-bar">
            @for (bookPrice of bookPrices; track bookPrice) {
              <div
                class="pill"
                >
                <input type="checkbox"
                  [checked]="selectedBookPrice.includes(bookPrice)"
                  (change)="setBookPrice($event)"
                  value="{{ bookPrice }}"
                  >
                {{ bookPrice }}
              </div>
            }
          </div>
        </div>
        <div class="promo-filters">
          <span class="filter-by">Site</span>
          <div class="pill-bar">
            <div class="pill">
              <input type="checkbox"
                [checked]="_selectedSite.includes('All')"
                (change)="setSite($event)"
                value="All"
                > All
              </div>
              @for (site of sites; track site) {
                <div
                  class="site-pill"
                  >
                <input type="checkbox"
                  [checked]="_selectedSite.includes(site.name)"
                  (change)="setSite($event)"
                  value="{{ site.name }}"
                  >
                <img src="{{ site.logoURL }}" class="site-logo" alt="{{ site.logoURL }}"> {{ site.name }}
              </div>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="drawer-footer">
      <button class="button regular outline-grey clear-btn" type="button" (click)="clearFilters()">Clear ({{ activeFilters }})</button>
      <button class="button regular apply-btn" type="button" (click)="applyFilters()">Apply</button>
    </div>
  </div>
</app-drawer>
